import { render, staticRenderFns } from "./inDevelopment.vue?vue&type=template&id=a56c15f2&scoped=true&"
import script from "./inDevelopment.vue?vue&type=script&lang=ts&"
export * from "./inDevelopment.vue?vue&type=script&lang=ts&"
import style0 from "./inDevelopment.vue?vue&type=style&index=0&id=a56c15f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c15f2",
  null
  
)

export default component.exports